 const TradeMarkPol=()=>{

    return(
        <>
        {/* <h1>TradeMark Policy</h1> */}
        <div style={{color:"#4189DD",fontSize:"18px",marginLeft:"5px",fontFamily:"Poppins"}}>Coming Soon!</div>
        </>
    )
 }
 export default TradeMarkPol;